import {Component} from 'react'

class ProductDetail extends Component {
  render() {
    const {product, onBack} = this.props
    let statusColor = ''

    switch (product.status) {
      case 'In Stock':
        statusColor = 'in-stock'
        break
      case 'Limited Stock':
        statusColor = 'limited'
        break
      default:
        statusColor = 'out-stock'
        break
    }
    return (
      <div type="button" className="detail-page">
        <div className="detail-card">
          <div className="detail-image-wrap">
            <button className="back-btn" onClick={onBack}>
              ← Back
            </button>

            <img
              src={product.imageUrl}
              alt={product.name}
              className="detail-image"
            />

            <div className="content-detail">
              <h2>{product.name}</h2>
              <p>
                <strong>Category:</strong> {product.category}
              </p>
              <p>
                <strong>Producer:</strong> {product.producer}
              </p>
              <p className={`badge ${statusColor}`}>Status :{product.status}</p>

              <h3>Disclosure Summary</h3>
              <p>Declared by: {product.declaredBy}</p>
              <p>Date: {product.date}</p>
              <p>Evidence Count: {product.evidenceCount}</p>

              <h3>Version History</h3>
              <ul>
                {product.versions.map(v => (
                  <li key={v.version}>
                    Version {v.version} {v.date}
                  </li>
                ))}
              </ul>

              <p className="disclaimer">
                !! This information is producer-declared and not independently
                verified. !!
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductDetail
